import { render, staticRenderFns } from "./SendMails.vue?vue&type=template&id=c0ceeddc&scoped=true&"
import script from "./SendMails.vue?vue&type=script&lang=js&"
export * from "./SendMails.vue?vue&type=script&lang=js&"
import style0 from "./SendMails.vue?vue&type=style&index=0&id=c0ceeddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ceeddc",
  null
  
)

export default component.exports